import Hero from "@/components/site/Hero";
import Pricing from "@/components/site/Pricing";
import WaitingPolicy from "@/components/site/WaitingPolicy";
import Tours from "@/components/site/Tours";
import Features from "@/components/site/Features";
import Contact from "@/components/site/Contact";
import Reviews from "@/components/site/Reviews";

const Home = () => (
  <main>
    <Hero />
    <Pricing />
    <WaitingPolicy />
    <Tours />
    <Features />
    <Contact />
    <Reviews />
  </main>
);

export default Home;
